export const SELECTION_KEY = "onlygrades-selection-v1";

const code = (value) =>
  String(value || "")
    .trim()
    .toUpperCase();
const normalizeCourses = (courses) => {
  const seen = new Set();
  return (Array.isArray(courses) ? courses : [])
    .flatMap((course) => {
      const courseCode = code(course?.course_code);
      if (!courseCode || seen.has(courseCode)) return [];
      seen.add(courseCode);
      return [
        {
          course_code: courseCode,
          course_name: String(course.course_name || courseCode),
        },
      ];
    })
    .slice(0, 8);
};

// One selection is shared by discovery, rankings and the chart workspace.
// Course codes are scoped to the institution; changing programme keeps the list.
export function createCourseSelection({
  storage,
  reactive = (value) => value,
} = {}) {
  const state = reactive({
    institution: "",
    program: "",
    courses: [],
    initialized: false,
    revision: 0,
  });
  const snapshot = () => ({
    institution: state.institution,
    program: state.program,
    courses: state.courses,
  });
  function commit(next, persist = true) {
    const value = {
      institution: code(next.institution),
      program: code(next.program),
      courses: normalizeCourses(next.courses),
    };
    if (!value.institution) value.program = "";
    if (
      state.initialized &&
      JSON.stringify(snapshot()) === JSON.stringify(value)
    )
      return;
    Object.assign(state, value, {
      initialized: true,
      revision: state.revision + 1,
    });
    if (persist)
      try {
        storage?.setItem(SELECTION_KEY, JSON.stringify(value));
      } catch {
        /* Storage is optional. */
      }
  }
  function hydrate(raw) {
    try {
      const value = JSON.parse(raw);
      if (!value || !Array.isArray(value.courses)) return;
      commit(value, false);
    } catch {
      /* Ignore invalid or unavailable storage. */
    }
  }
  try {
    hydrate(storage?.getItem(SELECTION_KEY));
  } catch {
    /* Storage is optional. */
  }
  return {
    state,
    hydrate,
    setContext({
      institution = state.institution,
      program = state.program,
    } = {}) {
      institution = code(institution);
      commit({
        institution,
        program,
        courses: institution === state.institution ? state.courses : [],
      });
    },
    replaceCourses(courses) {
      commit({ ...snapshot(), courses });
    },
    toggle(course, limit = 4) {
      const courseCode = code(course?.course_code);
      if (!courseCode) return;
      const selected = state.courses.some(
        (item) => item.course_code === courseCode
      );
      if (!selected && state.courses.length >= limit) return;
      commit({
        ...snapshot(),
        courses: selected
          ? state.courses.filter((item) => item.course_code !== courseCode)
          : [...state.courses, course],
      });
    },
    clear() {
      commit({ ...snapshot(), courses: [] });
    },
  };
}
